import { ButtonTypeTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, StackAlignItems, StackType, } from '@voltmoney/schema';
import React, { memo } from 'react';
import Space from '../space/Space';
import Typography from '../typography/Typography';
import { Pressable, View } from 'react-native';
import Stack from '../stack/Stack';
import Icon from '../icon/Icon';
import Button from '../button/Button';
import ThemeProvider from '@voltmoney/theme';
const Message = ({ label, customLabel, actionText, icon, onPress, triggerAction, action, alignText, bgColor = ColorTokens.Grey_Milk_1, labelColor = ColorTokens.Grey_Charcoal, actionIcon, }) => {
    const theme = ThemeProvider.getTheme();
    const backgroundColorValue = theme.colors[bgColor];
    const styleProps = React.useMemo(() => ({
        backgroundColor: backgroundColorValue,
    }), [backgroundColorValue]);
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    return (React.createElement(View, { style: [
            styleProps,
            {
                flexDirection: 'row',
                padding: 8,
                alignItems: 'center',
                justifyContent: 'flex-start',
                borderRadius: 8,
            },
        ] },
        React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center, flex: 1 },
            React.createElement(View, { style: {
                    flex: 1,
                    flexDirection: 'row',
                    // alignItems: 'center',
                    justifyContent: alignText,
                    alignItems: 'center'
                } },
                icon ? React.createElement(Icon, { ...icon }) : React.createElement(React.Fragment, null),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                customLabel ? (React.createElement(Typography, { ...customLabel })) : (React.createElement(React.Fragment, null)),
                label ? (React.createElement(Typography, { label: label, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, numberOfLines: 3 })) : (React.createElement(React.Fragment, null))),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            actionText ? (React.createElement(View, { style: { alignItems: 'flex-end' } },
                React.createElement(Button, { type: ButtonTypeTokens.SmallGhost, action: action, triggerAction: triggerAction, labelColor: ColorTokens.Primary_100, label: actionText }))) : (React.createElement(React.Fragment, null)),
            actionIcon ? (React.createElement(View, { style: { alignItems: 'flex-end' } },
                React.createElement(Pressable, { onPress: handleAction },
                    React.createElement(Icon, { ...actionIcon })))) : (React.createElement(React.Fragment, null)))));
};
export default memo(Message);
export { Message };
